"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerReady = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * A function to set the callback for when footer is ready / mounted
 * @param  {Function} callbackFn   A callback function
 */
const footerReady = callbackFn => {
    let prevReady;
    if (window_or_global_1.default._egFooterReadyCallback && typeof window_or_global_1.default._egFooterReadyCallback === 'function') {
        prevReady = window_or_global_1.default._egFooterReadyCallback;
    }
    window_or_global_1.default._egFooterReadyCallback = function () {
        if (callbackFn && typeof callbackFn === 'function') {
            callbackFn();
        }
        if (prevReady)
            prevReady.apply(this);
    };
};
exports.footerReady = footerReady;
//# sourceMappingURL=footer.js.map